import React from 'react';

import New from 'components/FeaturedAd/FeaturedAdComponent/Form';
export default (props) => <New {...props} formType="create" />;
